<template>
    <div class="index">
        <van-nav-bar title="红包充值" left-arrow @click-left="onClickLeft" />
        <div class="content" v-if="is_recharge_type == 2">
            <van-field
                v-model="rechargeAmount"
                type="number"
                required
                label="充值金额"
                placeholder="请输入充值金额"
                error-message-align="right"
                input-align="right"
                :rules="[{ required: true, message: '请输入充值金额' }]"
            />

            <van-divider style="width: 90%; margin: 0 auto" />

            <van-cell required title="上传凭证">
                <div style="float: right">
                    <van-uploader
                        @oversize="onOversize"
                        :after-read="afterRead"
                        v-model="fileList"
                        :max-count="1"
                    />
                </div>
                <div
                    style="
                        color: #999;
                        font-size: var(--base-px-12);
                        float: right;
                        margin: 10px var(--base-px-14) 0;
                        display: block;
                    "
                >
                    * 请上传充值凭证图片
                </div>
            </van-cell>

            <div
                style="padding-bottom: var(--base-px-20)"
                @click="submitRecharge"
            >
                <van-button
                    :loading="loading"
                    type="info"
                    style="
                        margin: 0 auto;
                        margin-top: var(--base-px-40);
                        width: 90%;
                    "
                    block
                >
                    提交申请
                </van-button>
            </div>
            <div
                style="
                    text-decoration: underline;
                    text-align: center;
                    color: #666666;
                "
                @click="toRechargeRecord"
            >
                充值记录
            </div>
        </div>
        <div class="content" v-else>
            <div class="recharge-amount-section">
                <div class="section-title">选择充值金额</div>
                <div class="amount-options">
                    <div
                        v-for="amount in rechargeAmounts"
                        :key="amount"
                        class="amount-item"
                        :class="{
                            'amount-item-selected': selectedAmount === amount,
                        }"
                        @click="selectAmount(amount)"
                    >
                        <div class="amount-value">￥{{ amount }}</div>
                    </div>
                </div>
            </div>

            <div class="recharge-info" v-if="selectedAmount">
                <div class="info-item">
                    <span class="info-label">充值金额：</span>
                    <span class="info-value">￥{{ selectedAmount }}</span>
                </div>
            </div>

            <div class="recharge-button-wrapper">
                <van-button
                    type="info"
                    block
                    :disabled="!selectedAmount"
                    :loading="loading"
                    @click="handleRecharge"
                    class="recharge-button"
                >
                    立即充值
                </van-button>
            </div>

            <div class="recharge-tips">
                <div class="tips-title">充值说明：</div>
                <div class="tips-content">1. 请选择充值金额后点击充值按钮</div>
                <div class="tips-content">2. 跳转至支付页面完成支付</div>
                <div class="tips-content">3. 若充值未到账，请及时联系客服</div>
            </div>

            <div
                style="
                    text-decoration: underline;
                    text-align: center;
                    color: #666666;
                    margin-top: var(--base-px-20);
                "
                @click="toRechargeRecord"
            >
                充值记录
            </div>
        </div>
    </div>
</template>

<script>
import {
    trafficRecharge,
    trafficUploadImage,
    trafficRechargePay,
    getRechargeList,
} from "../../api/traffic";
import { Toast } from "vant";

export default {
    data() {
        return {
            //1:支付充值 2:扫码上传凭证充值
            is_recharge_type: process.env.VUE_APP_IS_RECHARGE_TYPE,
            rechargeAmount: "",
            fileList: [],
            uploadedImage: "",
            uploadedImagePath: "",
            loading: false,
            uploadShow: "hideUpload",
            lastSubmitTime: 0, // 上次提交时间戳，用于节流
            // 支付充值相关
            rechargeAmounts: [], // 充值档次
            selectedAmount: null, // 选中的充值金额
        };
    },
    created() {
        if (this.is_recharge_type == 1) {
            this.get_recharge_list();
        }
    },
    methods: {
        get_recharge_list() {
            getRechargeList().then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.rechargeAmounts =
                        res.data.tenant_red_money_ewm_recharge_money_list.map(
                            (item) => Number(item)
                        );
                }
            });
        },
        onClickLeft() {
            this.$router.back();
        },
        // 文件大小限制
        onOversize(file) {
            this.$message.warning("文件大小不能超过 2MB");
        },
        // 上传文件
        afterRead(file) {
            // 如果是数组，取第一个
            const fileItem = Array.isArray(file) ? file[0] : file;

            fileItem.status = "uploading";
            fileItem.message = "上传中...";
            this.uploadShow = "showUpload";
            var formData = new FormData();
            formData.append("image", fileItem.file);
            trafficUploadImage(formData)
                .then((res) => {
                    console.log(res, "res");
                    if (res.code == 1) {
                        this.uploadShow = "hideUpload";
                        fileItem.status = "success";
                        fileItem.message = "上传成功";
                        this.fileList = [fileItem];
                        // 根据接口返回格式获取图片路径
                        this.uploadedImage = res.data.file_name;
                        this.uploadedImagePath = res.data.file_url;
                    } else {
                        this.uploadShow = "hideUpload";
                        fileItem.status = "failed";
                        fileItem.message = "上传失败";
                        this.$message.error("图片上传失败，请重试");
                    }
                })
                .catch((err) => {
                    this.uploadShow = "hideUpload";
                    fileItem.status = "failed";
                    fileItem.message = "上传失败";
                    this.$message.error("图片上传失败，请重试");
                });
        },
        // 提交充值申请（带节流功能）
        submitRecharge() {
            // 节流：防止重复提交，2秒内只能提交一次
            const now = Date.now();
            if (this.loading) {
                return; // 如果正在提交中，直接返回
            }
            if (now - this.lastSubmitTime < 2000) {
                return;
            }

            // 验证必填项
            if (!this.rechargeAmount) {
                this.$message.warning("请输入充值金额");
                return;
            }

            if (!this.uploadedImagePath) {
                this.$message.warning("请上传充值凭证");
                return;
            }

            // 验证金额格式
            const amount = parseFloat(this.rechargeAmount);
            if (isNaN(amount) || amount <= 0) {
                this.$message.warning("请输入有效的充值金额");
                return;
            }

            // 更新上次提交时间
            this.lastSubmitTime = now;
            this.loading = true;

            const data = {
                money: amount,
                recharge_img_url: this.uploadedImage,
            };

            trafficRecharge(data)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.fileList = [];
                        this.uploadedImage = "";
                        this.uploadedImagePath = "";
                        this.rechargeAmount = "";
                        this.$message.success("充值申请提交成功");
                    } else {
                        this.loading = false;
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        toRechargeRecord() {
            this.$router.push("/index/rechargeList");
        },
        // 选择充值金额
        selectAmount(amount) {
            this.selectedAmount = amount;
        },
        // 处理充值
        handleRecharge() {
            if (!this.selectedAmount) {
                Toast({ position: "top", message: "请选择充值金额" });
                return;
            }

            // 防止重复提交
            if (this.loading) {
                return;
            }

            this.loading = true;

            trafficRecharge({
                money: this.selectedAmount,
            })
                .then((res) => {
                    this.loading = false;
                    if(res.code==1){
                        location.href = res.data.counter_url;
                    }else{
                        Toast.fail(res.msg||res.message);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    console.error("充值失败：", err);
                    Toast.fail("充值失败，请重试");
                });
        },
    },
};
</script>

<style lang="less" scoped>
.index {
    font-size: var(--base-px-14);
    height: 100%;
    background: #fff;

    .hideUpload {
        opacity: 1;
    }

    .showUpload {
        opacity: 1;
    }

    .content {
        background: #fbfbfb;
        min-height: 92%;
        padding: var(--base-px-20) var(--base-px-16);

        .titles {
            padding: var(--base-px-5) var(--base-px-14);
            font-size: var(--base-px-14);
            color: #444;
            font-weight: bold;
            border-bottom: var(--base-px-7) solid #f2f4f8;
        }
    }

    .recharge-amount-section {
        background: #ffffff;
        border-radius: var(--base-px-8);
        padding: var(--base-px-20);
        margin-bottom: var(--base-px-20);

        .section-title {
            font-size: var(--base-px-16);
            font-weight: bold;
            color: #333333;
            margin-bottom: var(--base-px-16);
        }

        .amount-options {
            display: flex;
            flex-wrap: wrap;
            gap: var(--base-px-12);
        }

        .amount-item {
            flex: 1;
            min-width: calc(50% - var(--base-px-6));
            background: #f5f7f7;
            border: 2px solid transparent;
            border-radius: var(--base-px-8);
            padding: var(--base-px-16);
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;

            &:active {
                transform: scale(0.98);
            }

            .amount-value {
                font-size: var(--base-px-18);
                font-weight: bold;
                color: #333333;
            }

            &.amount-item-selected {
                background: #e8f4ff;
                border-color: #007aff;

                .amount-value {
                    color: #007aff;
                }
            }
        }
    }

    .recharge-info {
        background: #ffffff;
        border-radius: var(--base-px-8);
        padding: var(--base-px-16) var(--base-px-20);
        margin-bottom: var(--base-px-20);

        .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: var(--base-px-14);

            .info-label {
                color: #666666;
            }

            .info-value {
                color: #007aff;
                font-weight: bold;
                font-size: var(--base-px-18);
            }
        }
    }

    .recharge-button-wrapper {
        margin: var(--base-px-30) 0;
    }

    .recharge-button {
        background: linear-gradient(to right, #117de9, #2b62cc);
        border: none;
        height: var(--base-px-44);
        border-radius: var(--base-px-22);
        font-size: var(--base-px-16);
        font-weight: bold;

        &:disabled {
            background: #cccccc;
            opacity: 0.6;
        }
    }

    .recharge-tips {
        background: #ffffff;
        border-radius: var(--base-px-8);
        padding: var(--base-px-16) var(--base-px-20);
        margin-top: var(--base-px-20);

        .tips-title {
            font-size: var(--base-px-14);
            font-weight: bold;
            color: #333333;
            margin-bottom: var(--base-px-10);
        }

        .tips-content {
            font-size: var(--base-px-12);
            color: #666666;
            line-height: 1.8;
            margin-bottom: var(--base-px-4);
        }
    }
}
</style>
